<template>
  <div>
    <div class="card w-100">
      <div class="card-body">
        <h5 class="card-title mb-4">Calculadora Dutching / Bookmaking</h5>
        <div class="row">

          <div class="col-12 mt-3" style="text-align:left">
            <label>Realizar entradas em: </label>
            <div class="form-check form-check-inline" style="margin-left: 20px;">
              <input class="form-check-input" type="radio" v-model="selected" name="inlineRadioOptions" id="inlineRadio1" value="back">
              <label class="form-check-label" for="inlineRadio1">Dutching (multi-back)</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="selected" name="inlineRadioOptions" id="inlineRadio2" value="lay">
              <label class="form-check-label" for="inlineRadio2">Bookmaking (multi-lay)</label>
            </div>
          </div>
          
          <div v-show="selected == 'back'">
            <MultiBack />
          </div>

          <div v-show="selected == 'lay'">
            <MultiLay />
          </div>

          <div class="col-12 mt-3">
            <div class="clubedaaposta">
              <label>clubedaposta.com</label>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultiBack from './Dutching/MultiBack';
import MultiLay from './Dutching/MultiLay';

export default {
  name: 'DutchingCalculator',
  components: {
    MultiBack,
    MultiLay
  },
  data () {
    return {
      selected: 'back',
      options: [
        { text: 'Back', value: 'back' },
        { text: 'Lay', value: 'lay' },
      ]
    }
  }
}
</script>

<style scoped>
.input-format-grey {
  padding-left: 200px;
}
.input-format-green {
  padding-left: 190px;
}
.icon-add-remove {
  border: 1px solid #333B42;
  border-radius: 5px;
  opacity: 1;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  margin-top: 20px;
}
.icon-add-remove {
  border: 1px solid #333B42;
  border-radius: 5px;
  opacity: 1;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  margin-top: 20px;
  background: #FFF;
  transition: 0.2s linear;
}
.add:hover {
  background: var(--unnamed-color-ffb01f);
  color: white;
  border-color: white;
}
.remove:hover {
  background: #333B42;
  color: white;
  border-color: #333B42;
}
</style>
